<tt-page>
    <tt-page-heading ttModel="h_p2settings" ttTranslate></tt-page-heading>
    <div class="col-xs-12 sp-0 flex-1">
        <div class="col-xs-12 col-md-3 sp-5 height-full flex-column">
            <tt-card>
                <tt-input ttLabel="searchtext" [(ttModel)]="filter" ttShowClearButton></tt-input>
                <tt-button *ngIf="!(['mobile', 'tablet'] | mediaQuery)" ttText="new" ttType="link" ttIcon="far fa-plus" ttIconAlign="left" (ttClick)="selectedSettingId = '0'"></tt-button>
                <tt-button-goto
                    *ngIf="['mobile', 'tablet'] | mediaQuery"
                    ttText="new"
                    ttType="link"
                    ttIcon="far fa-plus"
                    ttGoto="p2settingedit"
                    [ttGotoParms]="{ p2_setting_keyno: '0' }"
                ></tt-button-goto>
            </tt-card>
            <tt-list
                ttHeightFull
                class="flex-1"
                [ttRadioSelection]="!(['mobile', 'tablet'] | mediaQuery)"
                [(ttSelectedId)]="selectedSettingId"
                (ttSelectedIdChange)="grid.gridfunc?.read?.()"
                [ttData]="settings"
                [ttFilter]="filter"
                [ttGoto]="['mobile', 'tablet'] | mediaQuery"
            ></tt-list>
        </div>
        <div *ngIf="!(['mobile', 'tablet'] | mediaQuery)" class="col-xs-9 sp-0 height-full flex-column sp-5" style="overflow: auto">
            <tt-card
                *ngIf="selectedSettingId > ''"
                class="col-xs-5 sp-5"
                [ttHeading]="selectedSettingId > '0' ? 'h_p2setting_edit' : 'h_p2setting_new'"
                [ttIcon]="selectedSettingId > '0' ? 'far fa-pencil' : 'far fa-sparkles'"
            >
                <tt-p2-setting-edit-form [params]="{ p2_setting_keyno: selectedSettingId }" (submit)="onSettingSubmitted($event)"></tt-p2-setting-edit-form>
            </tt-card>
            <tt-card [hidden]="!(selectedSettingId > '0')" class="p-5 flex-1" ttClass="p-0 height-full flex-column" ttHeading="h_p2setting_webpages" ttIcon="far fa-cog" style="min-height: 500px">
                <tt-grid class="flex-1" [(ttOptions)]="grid"></tt-grid>
            </tt-card>
        </div>
    </div>
</tt-page>
